// extracted by css-extract-rspack-plugin
export default {"filterTitle":"qsRxb_FxORM_KiRy"};